export const GET_CLUB_BILLING_STATUS = `
  query GetClubBillingStatus($clubId: String!) {
    getClubBillingStatus(clubId: $clubId) {
      clubId
      billingEnabled
      billingState
      nextAction
      billingAccessMode
      trialConsumed
      status
      currentPeriodEnd
      trialEnd
      pastDueSince
      cancelAtPeriodEnd
      canViewBilling
      canManageBilling
    }
  }
`;

export const CREATE_CLUB_CHECKOUT_SESSION = `
  mutation CreateClubCheckoutSession($clubId: String!) {
    createClubCheckoutSession(clubId: $clubId) {
      url
    }
  }
`;

export const CREATE_BILLING_PORTAL_SESSION = `
  mutation CreateBillingPortalSession($clubId: String!) {
    createBillingPortalSession(clubId: $clubId) {
      url
    }
  }
`;

const CLUB_BILLING_IDENTITY_FIELDS = `
  clubId
  country
  nationalTaxId
  normalizedTaxId
  billingEmail
  legalName
  legalForm
  address {
    line1
    line2
    city
    postalCode
    region
    country
  }
  verification {
    status
    provider
    fallbackFromProvider
    checkedAt
    verifiedAt
  }
  canStartCheckout
  createdAt
  updatedAt
`;

export const GET_CLUB_BILLING_IDENTITY = `
  query GetClubBillingIdentity($clubId: String!) {
    getClubBillingIdentity(clubId: $clubId) {
      ${CLUB_BILLING_IDENTITY_FIELDS}
    }
  }
`;

export const VERIFY_CLUB_BILLING_IDENTITY = `
  mutation VerifyClubBillingIdentity(
    $clubId: String!
    $input: ClubBillingIdentityVerificationInput!
  ) {
    verifyClubBillingIdentity(clubId: $clubId, input: $input) {
      ${CLUB_BILLING_IDENTITY_FIELDS}
    }
  }
`;

export const UPDATE_CLUB_BILLING_EMAIL = `
  mutation UpdateClubBillingEmail($clubId: String!, $billingEmail: String!) {
    updateClubBillingEmail(
      clubId: $clubId
      billingEmail: $billingEmail
    ) {
      ${CLUB_BILLING_IDENTITY_FIELDS}
    }
  }
`;
